module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Tutoring_Poster-95a7adb43c0560029b053848f9433a72.jpg";